import gridCol from '@/libs/frontwise-editor/gridCol.js'
import gridRow from '@/libs/frontwise-editor/gridRow.js'
import toolsRTE from '@/libs/frontwise-editor/toolsRTE.js'
import toolsSortable from '@/libs/frontwise-editor/toolsSortable.js'
import contentEditorElements from '@/libs/frontwise-editor/contentEditorElements.js'

const TOOLS_SINGLE_PANEL_ID = 'geToolsPanelSingle'
let $panel = $('#' + TOOLS_SINGLE_PANEL_ID)
let fwSettings = null

const VALID_COMPONENT_NAMES = [
  'NavBar',
  'icon',
  'Spreadsheet',
  'input-tag',
  'PivotTable',
  'PostsWidget',
  'vue-draggable-resizable',
  'codemirror',
  'DataGrid',
  'Chart',
  'ChartOnly',
  'GanttChart',
  'GanntSimple',
  'TipTapEditor',
  'PivotGrid',
  'VueSlider',
  'DatePicker',
  'multiselect',
  'FullCalendar',
  'DataGridEditRow',
  'OrganizationChart',
  'Kanban',
  'Diagram',
  'workflowButtons',
  'Treeselect',
  'paginate',
  'HandyScroll',
  'vue-qr',
  'qrcode-stream',
  'SimpleWorkflow'
]

export default {
  /**
   * Append single tools panel to page
   */
  init (settings) {
    fwSettings = settings
    $panel = $('#' + TOOLS_SINGLE_PANEL_ID)
    if (!$panel.length) {
      $panel = $('<div id="' + TOOLS_SINGLE_PANEL_ID + '" class="ge-tools-drawer single" />')
      $panel.appendTo('body')
    }
    return $panel
  },

  /**
   * Remove single tools panel
   */
  deinit () {
    $panel = $('#' + TOOLS_SINGLE_PANEL_ID)
    if ($panel.length) {
      $panel.remove()
    }
  },

  /**
   * Move single tools panel position
   * into top left corner of selected el
   * JQuery.UI required
   */
  onElSelected ($el, updateTemplate) {
    toolsSortable.deinit()
    let tools = []

    tools.push(toolsSortable.getTool())
    tools.push(this.getRemoveTool($el))

    if ($el.hasClass('column')) {
      tools = tools.concat(gridCol.getTools(
        $el,
        gridRow.create().append(gridCol.create(6)).append(gridCol.create(6)),
        function () {
          initContentEditor($el, updateTemplate)
        },
        fwSettings))
    }

    if ($el.hasClass('row')) {
      tools = tools.concat(gridRow.getTools(
        $el,
        gridCol.create(4)
      ))
    }

    this.setTools(tools)

    $('#panel').on('scroll', function () {
      repositionPanel($el)
    })
    $('.grid-stack-item-content').on('scroll', function () {
      repositionPanel($el)
    })

    repositionPanel($el)
  },

  /**
   * tool format {title: '', className: '', iconClass: '', eventHandlers: function|object}
   * @param toolsObjList array
   */
  setTools (toolsObjList) {
    $panel = $('#' + TOOLS_SINGLE_PANEL_ID)
    $panel.html('')
    for (let tool of toolsObjList) {
      this.create($panel, tool.title, tool.className, tool.iconClass, tool.eventHandlers)
    }
  },

  create (drawer, title, className, iconClass, eventHandlers) {
    let tool = $('<a title="' + title + '" class="tools ' + className + '"><i class="' + iconClass + '"></i></a>')
      .appendTo(drawer)

    if (typeof eventHandlers === 'function') {
      tool.on('click', eventHandlers)
    }
    if (typeof eventHandlers === 'object') {
      $.each(eventHandlers, function (name, func) {
        tool.on(name, func)
      })
    }
  },

  /**
   * Run custom content filter on init and deinit
   */
  runFilter (isInit, customFilter) {
    if (customFilter.length) {
      $.each(customFilter, function (key, func) {
        if (typeof func === 'string') {
          func = window[func]
        }

        func(canvas, isInit)
      })
    }
  },

  getLayoutSelector (canvas) {
    let layoutDropdown = $('<div class="dropdown pull-right ge-layout-mode">' +
      '<button type="button" class="btn btn-sm btn-primary dropdown-toggle" data-toggle="dropdown">Desktop</button>' +
      '<div class="dropdown-menu" role="menu">' +
      '<a class="dropdown-item" data-width="auto" title="Desktop">Desktop</a>' +
      '<a class="dropdown-item" title="Tablet">Tablet' +
      '<a class="dropdown-item" title="Phone">Phone</a>' +
      '</div>' +
      '</div>')
      .on('click', 'a', function () {
        gridCol.switchLayout($(this).index(), canvas)
        layoutDropdown.find('button').text($(this).text())
      })
    return layoutDropdown
  },

  getEditSourceCodeButton (canvas, htmlTextArea, init, deinit) {
    let htmlButton = $('<button title="Edit Source Code" type="button" class="btn btn-sm btn-primary gm-edit-mode"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-right"></i></span></button>')
      .on('click', function () {
        if (htmlButton.hasClass('active')) {
          canvas.empty().html(htmlTextArea.val()).show()
          init()
          htmlTextArea.hide()
        } else {
          deinit()
          htmlTextArea
            .height(0.8 * $(window).height())
            .val(canvas.html())
            .show()

          canvas.hide()
        }

        htmlButton.toggleClass('active btn-danger')
      })
    return htmlButton
  },

  getPreviewButton (canvas) {
    let previewButton = $('<button title="Preview" type="button" class="btn btn-sm btn-primary gm-preview"><i class="fa fa-eye"></i></button>')
      .on('mouseenter', function () {
        canvas.removeClass('ge-editing')
      })
      .on('click', function () {
        previewButton.toggleClass('active btn-danger').trigger('mouseleave')
      })
      .on('mouseleave', function () {
        if (!previewButton.hasClass('active')) {
          canvas.addClass('ge-editing')
        }
      })
    return previewButton
  },

  getRemoveTool ($el) {
    return {
      title: 'Remove', className: 'ge-remove', iconClass: 'fa fa-trash', eventHandlers: function () {
        if (window.confirm('Are you sure delete selected element?')) {
          $el.animate({
            opacity: 'hide',
            width: 'hide',
            height: 'hide'
          }, 400, function () {
            $el.remove()
            $('#' + TOOLS_SINGLE_PANEL_ID).removeAttr('style')
          })
        }
      }
    }
  },

  fixVueComponentNames (html) {
    for (const componentName of VALID_COMPONENT_NAMES) {
      let re = new RegExp(componentName.toLowerCase(), "gi");
      html = html.replace(re, componentName)
    }
    return html
  }
}

function initContentEditor (col, updateTemplate) {
  contentEditorElements.actions.render(
    col,
    toolsRTE.getRTE('summernote').initialContent,
    contentEditorElements.actionAttr,
    contentEditorElements.modalId,
    contentEditorElements.templates,
    updateTemplate
  )
}

function repositionPanel($el) {
  $('#' + TOOLS_SINGLE_PANEL_ID).position({
    my: 'left bottom',
    at: 'left top',
    of: $el,
    collision: 'fit'
  })
}
